import type { Prices } from './priceFormat'

export const getFloatingSummaryCompareAtPrice = (
    priceInfo: Prices,
): number | null => {
    return priceInfo.compareAtPrice != null &&
        priceInfo.compareAtPrice > priceInfo.price
        ? priceInfo.compareAtPrice
        : null
}
